import * as React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { TermsAndConditions } from './TermsAndConditions';

export const TermsAndConditionsPage = () => {
  return (
    <>
      <DocumentHead title='Terms and conditions' />
      <PageTemplate main={<TermsAndConditions />} />
    </>
  );
};
